<template>
  <v-container v-resize="onResize" style="padding: 0px; max-width: 100%">
    <DashboardComponent
      mod="cul"
      :grid.sync="layout"
      :updated.sync="layoutUpdate"
      :comps="comps"
      :size="size"
      :height="height"
    />
  </v-container>
</template>
<script>
import ApexColumn from "@/../../coreui/library/ApexColumn";
import ApexRangebar from '@/../../coreui/library/ApexRangebar'
import ApexDonut from "@/../../coreui/library/ApexDonut";
import DashboardComponent from "@/../../coreui/library/DashboardComponent";
import TextItem from "@/../../coreui/library/TextGridItem";
import helper from "./helper";
import { sync } from "vuex-pathify";

export default {
  components: {
    DashboardComponent,
  },
  data: () => ({
    strains: { fvalues: null, vvalues: null, xvalues: null, dvalues: null },
    lastheight: 40,
    height: 40,
    windowSize: {
      x: 0,
      y: 0,
    },
    harvests: { labels: [], values: [] },
    strains: { labels: [], values: [] },
    trims: { labels: [], values: [], fvalues: [], svalues: [], tvalues: [] },
    plantings: { labels: [], values: [] },

    stateValues: {},
    plantedDates: [],
    growPhase: [],
    strainCount: [],
    labels: [],
    values: [],
    timelines: [],
    debouncer: true,
    layoutUpdate: false,
    layout: [
      {
        x: 0,
        y: 0,
        w: 2,
        h: 1,
        i: 0,
        static: true,
        isDraggable: false,
        isResizable: false,
      },
      {
        x: 2,
        y: 0,
        w: 2,
        h: 1,
        i: 1,
        static: true,
        isDraggable: false,
        isResizable: false,
      },
      {
        x: 4,
        y: 0,
        w: 2,
        h: 1,
        i: 2,
        static: true,
        isDraggable: false,
        isResizable: false,
      },
      {
        x: 6,
        y: 0,
        w: 2,
        h: 1,
        i: 3,
        static: true,
        isDraggable: false,
        isResizable: false,
      },
      {
        x: 8,
        y: 0,
        w: 2,
        h: 1,
        i: 4,
        static: true,
        isDraggable: false,
        isResizable: false,
      },
      {
        x: 10,
        y: 0,
        w: 2,
        h: 1,
        i: 5,
        static: true,
        isDraggable: false,
        isResizable: false,
      },
      { x: 0, y: 2, w: 4, h: 6, i: 6 },
      { x: 4, y: 2, w: 4, h: 6, i: 7 },
      { x: 8, y: 2, w: 4, h: 6, i: 8 },
      { x: 0, y: 7, w: 12, h: 6, i: 9 },
      // { x: 6, y: 7, w: 6, h: 6, i: 10 },
    ],
    size: 12,
  }),

  computed: {
    width() {
      this.windowSize.x / 12;
    },
    // theme: sync('theme'),
    // themeMenu: sync('themeMenu'),
    facility: sync("login/facility"),
    mqttTableUpdated: sync("mqtt/mqttTableUpdated"),
    comps() {
      var self = this
      return [
        {
          args: {
            s: 0,
            label: "Wet Weight",
            value: this.harvests.totalWeight
              ? this.harvests.totalWeight.toFixed(2) +
                " " +
                this.harvests.weightUnit
              : "",
          },
          component: TextItem,
        },
        {
          args: {
            s: 1,
            label: "Harvested Plants",
            value: this.harvests.totalCount || 0,
          },
          component: TextItem,
        },
        {
          args: {
            s: 2,
            label: "Live Plants",
            value: this.strains.totalCount || 0,
          },
          component: TextItem,
        },
        {
          args: {
            s: 3,
            label: "Total Flower",
            value:
              (this.trims.totalFlowerWeight
                ? this.trims.totalFlowerWeight.toFixed(2)
                : "0") +
              " " +
              (this.harvests.weightUnit ? this.harvests.weightUnit : ""), //' lb',
          },
          component: TextItem,
        },
        {
          args: {
            s: 4,
            label: "Total Smalls",
            value:
              (this.trims.totalSmallsWeight
                ? this.trims.totalSmallsWeight.toFixed(2)
                : "0") +
              " " +
              (this.harvests.weightUnit ? this.harvests.weightUnit : ""), //|| 0 +' lb'
          },
          component: TextItem,
        },
        {
          args: {
            s: 5,
            label: "Total Trim",
            value:
              (this.trims.totalTrimWeight
                ? this.trims.totalTrimWeight.toFixed(2)
                : "0") +
              " " +
              (this.harvests.weightUnit ? this.harvests.weightUnit : ""), //|| 0+' lb'
          },
          component: TextItem,
        },
        {
          args: {
            name: "widget 2",
            values: [{ name: "Weight", data: this.harvests.values }],
            empty: this.harvests.values.length < 1,
            unit: this.harvests.weightUnit ? this.harvests.weightUnit : "",
            labels: this.harvests.labels,
            title: "Harvests",
            subtitle: "Wet Weights",
            graphSub: "Weight",
            fullscreen: true,
            s: 6,
            height: this.height,
            width: this.width,
            date: true,
            palette_light: "palette6",
            palette_dark: "palette4",
            loading: false,
            toolTipFormatter: function(val) {
              return (
                '<div class="arrow_box">' +
                self.harvests.labels[val.dataPointIndex] + 
                '<br />' + 
                self.harvests.values[val.dataPointIndex] + ' ' + self.harvests.weightUnit 
              );
            }
          },
          component: ApexColumn, 
        },
        {
          args: {
            name: "widget 2",
            values: [
              {
                name: "Plant Count",
                data: this.harvests.counts ? this.harvests.counts : [],
              },
            ],
            empty: !this.harvests || !this.harvests.counts || this.harvests.counts < 1,
            labels: this.harvests.countlabels,
            title: "Harvests",
            subtitle: "Plant Count",
            fullscreen: true,
            s: 7,
            height: this.height,
            width: this.width,
            annotate: false,
            loading: false,
            palette_light: "palette7",
            palette_dark: "palette8",
          },
          component: ApexDonut, 
        },
        {
          args: {
            stacked: true,
            name: "widget 2",
            values: [
              {
                name: "Flower",
                data: this.trims.fvalues ? this.trims.fvalues : [],
              },
              {
                name: "Smalls",
                data: this.trims.svalues ? this.trims.svalues : [],
              },
              {
                name: "Trim",
                data: this.trims.tvalues ? this.trims.tvalues : [],
              },
            ],
            empty: this.trims.fvalues.length < 1 && this.trims.svalues.length < 1 && this.trims.tvalues.length < 1, //true,
            labels: this.trims.labels,
            title: "Processed Harvests",
            subtitle: "Dry Weight",
            fullscreen: true,
            s: 8,
            height: this.height,
            width: this.width,
            // 'colorize': true,
            annotate: false,
            loading: false,
            palette_light: "palette8",
            palette_dark: "palette2",
          },
          component: ApexColumn,
        },
        {
          args: {
            name: "widget 1",
            values: this.timelines.data,
            title: "Plants Life Cycle",
            subtitle: "By Active Harvests",
            fullscreen: true,
            toolTipFormatter: function toolTipFormatter(seriesindex,dataindex) {
              let totaldays =  Math.ceil((self.timelines.data[1]['data'][dataindex]['y'][1] - self.timelines.data[0]['data'][dataindex]['y'][0] )/ (1000 * 60 * 60 * 24))
              let totalweight = self.timelines.extra[dataindex]['weight']['qty']
              let unit = self.timelines.extra[dataindex]['weight']['unit']
              let totalcount = self.timelines.extra[dataindex]['count']
              return (
                '<div class="arrow_box">' +
                self.timelines.data[seriesindex]['data'][dataindex]['x'] +
                "<br/>" +
                (seriesindex == 0 ? 'vegetative: ' : 'flowering: ') +
                Math.ceil((self.timelines.data[seriesindex]['data'][dataindex]['y'][1] - self.timelines.data[seriesindex]['data'][dataindex]['y'][0] )/ (1000 * 60 * 60 * 24)) + ' days' +
                ', total: ' +
                totaldays + ' days' +
                "<br/>" +
                totalweight + ' ' + unit + ', ' + totalcount + ' plants' +
                "<br/>" +
                "yield: " + (totalweight/totalcount).toFixed(2)  + unit + ' per plant, ' +
                (totalweight/totalcount/totaldays).toFixed(5) + unit + ' per plant/day' +
                "</div>"
              );
            },
            s: 9,
            height: this.height,
            width: this.width,
            loading: false,
            palette_light: "palette9",
            palette_dark: "palette6",
          },
          component: ApexRangebar 
        },
      ];
    },
  },
  watch: {
    async facility(val, old) {
      if (val == old) {
        return;
      }
      await this.getData();
    },
		args: {
      immediate: true,
      deep: true,
      handler(val) {
				// this.series = val.values
				this.height = "100%"
				// console.log('original values length ', val.values)
        // this.series = this.fullScreen ? val.values.slice(0,19) : val.values.slice(0,5)
				// console.log('truncated values length ', this.series.length)
      },
    },
    mqttTableUpdated: {
      async handler(val) {
        this.elog("debug", "mqtt callback for updating table: {}", val)();
        if (
          val == "cul_harvest" ||
          val == "cul_process" ||
          val == "cul_trim" ||
          val == "cul_palntings"
        ) {
          await this.getData();
        }
        this.mqttTableUpdated = "";
      },
    },
    layout: {
      deep: true,
      handler: function (newVal, oldVal) {
        // console.log('in cultivation: layout updated', newVal)
      },
    },
  },
  methods: {
    onResize() {
      this.windowSize = { x: window.innerWidth, y: window.innerHeight };
      if (this.windowSize.y != this.lastheight) {
        this.height = this.windowSize.y;
        this.lastheight = this.height;
      }
    },
    getCurTime() {
      // return new Date(2020, 4, 15)
      let d = new Date(Date.now());
      return d;
    },

    async getData() {
      let self = this
      for (let i = 0; i < this.comps.length; i++) {
        this.comps[i].args.loading = true;
      }
      helper.getHarvests().then((data)=>  {
        self.harvests = data;
        self.comps[6].args.loading = false;
        self.comps[7].args.loading = false;
      }); // 6,7
      helper.getStrains().then((data) => {
        self.strains = data
        self.comps[6].args.loading = false;
      });
      helper.getTrims().then((data) => {
        self.trims = data
        self.comps[8].args.loading = false;
      }); 
      helper.getHarvestTimelines().then((data) => {
        self.timelines = data
        self.comps[9].args.loading = false;
      }) 
      this.elog(
        "trace",
        "Dashboard Data - harvests {}, strains {}, trims {}, plantings {}, timelines{}",
        this.harvests,
        this.strains,
        this.trims,
        this.plantings,
        this.timelines
      )();
    },
  },

  async mounted() {
    await this.getData();
  },

  beforeDestroy() {
    // this.themeMenu = false
  },
};
</script>

